<script setup>
import {useFullscreen} from '@vueuse/core'
import {computed} from "vue"

import LoyaltyBar from "@shared/components/molecules/LoyaltyBar.vue"
import TournamentBar from "@shared/components/molecules/TournamentBar.vue"
import {useGamePlayStore} from "@shared/stores/GamePlayStore"
import {useLoyaltyChestStore} from "@shared/stores/LoyaltyChestStore"
import {useTournamentStore} from "@shared/stores/TournamentStore"

const {isFullscreen, toggle} = useFullscreen()

const gamePlayStore = useGamePlayStore()
const loyaltyChestStore = useLoyaltyChestStore()
const tournamentStore = useTournamentStore()

const isTournamentBarVisible = computed(() => {
    const isTournamentGame = tournamentStore.tournament?.games.find(g => g.game_id === gamePlayStore.currentGameId)
    const startTournamentCondition = isTournamentGame && tournamentStore.isTournamentRunning && tournamentStore.isCurrentTournament

    return startTournamentCondition || tournamentStore.isTournamentProgressWatching
})

const handleCloseGame = () => {
    tournamentStore.stopWatchingTournamentProgress()
    gamePlayStore.stopCurrentGame()
}

</script>

<template>
    <div id="divAppGame"
         v-if="gamePlayStore.currentGameId"
         class="show"
    >
        <div class="divGameOverlay"></div>
        <div id="divGamePopup"
             :class="{ 'fullscreen': isFullscreen }"
        >
            <div id="divGameName">{{ gamePlayStore.game?.name }}</div>
            <div id="divGameProduct" class="show">{{ gamePlayStore.game?.product }}</div>

            <TournamentBar v-if="isTournamentBarVisible"
               :game-id="gamePlayStore.currentGameId"
            />

            <LoyaltyBar v-else-if="appHasLoyalty"
                id="lbrLoyaltyBar"
                @click="() => loyaltyChestStore.setLoyaltyChestModalVisible(true)"
            />

            <div id="btnFullscreenGame" @click="toggle"></div>
            <div id="btnCloseGame" @click="handleCloseGame"></div>
            <div class="divGameLoader">

                <iframe
                    v-if="gamePlayStore.gameUrl"
                    title="Game Play"
                    class="gameIframe"
                    style="border: none; overflow: hidden;"
                    :src="gamePlayStore.gameUrl"
                />

                <template v-else>
                    <div class="divGameLoaderIcon fa fa-refresh"></div>
                    <div class="divGameLoaderText">Loading...</div>
                </template>
            </div>
        </div>
    </div>
</template>

<style>
#divAppGame {
    z-index: 10;
}

@media (max-width: 1240px) {
    #divAppGame #divGamePopup {
        height: 100% !important;
        width: 100% !important;
    }
}

@media (max-width: 800px) {
    #divAppGame #divGamePopup {
        height: 100% !important;
        width: 100% !important;
    }
}
</style>
